import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { useApiClient } from "../../../../shared/hooks/useApiClient";
import { whistleblowerKeys } from "../utils/whistleblowerKeys";
import { IWhistleblowerApiEntity } from "../types/Whistleblower";

export interface IWhistleblowerUpdateRequest {
  code: string;
  photos: Array<number>;
  message: string;
}

export const useWhistleblowerUpdate = () => {
  const queryClient = useQueryClient();
  const apiClient = useApiClient();

  const updateWhistleBlower = async (
    data: IWhistleblowerUpdateRequest
  ): Promise<AxiosResponse<IWhistleblowerApiEntity>> => {
    return await apiClient.post<IWhistleblowerApiEntity>(
      "/whistleblower/update",
      {
        ...data
      }
    );
  };

  return useMutation(updateWhistleBlower, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(whistleblowerKeys.all);
    }
  });
};
